import type { Tag } from "@/types"

// Tag names ship with a taxonomy prefix ("strategic_intent:lived-experience").
// The label drops the prefix; the full string lives on `tag.name` for
// admin tooling and analytics.
export function tagLabel(tag: Pick<Tag, "name">): string {
  return tag.name.replace(/^[A-Za-z]+:/, "")
}
